import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import ApiService from "../../ApiService";
import {AsyncJsonViewer} from "../../AsyncJsonViewerCard";

interface DevStatusPageProps {
    apiService: ApiService
}

interface DevStatusPageState {
}

class DevStatusPage extends Component<DevStatusPageProps & DispatchProps, DevStatusPageState> {
    static displayName = DevStatusPage.name;

    constructor(props: DevStatusPageProps & DispatchProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<DevStatusPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    render() {
        return (
            <Fragment>
                <PageTitle title={"Dev Status"}/>
                
                <AsyncJsonViewer title={"Admin Status"} getData={() => this.props.apiService.getAdminAppStatus()}/>
                <AsyncJsonViewer title={"Mailroom Status"} getData={() => this.props.apiService.getMailroomAppStatus()}/>
                <AsyncJsonViewer title={"Workloads Status"} getData={() => this.props.apiService.getWorkloadsAppStatus()}/>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState): DevStatusPageProps => {
        return {
            apiService: state.auth.apiService
        };
    }
)(DevStatusPage)